import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [{
        path: "/",
        name: "Home",
        redirect: "/home",
    },
    {
        path: "/home",
        name: "Home",
        component: () =>
            import ("../views/Home.vue"),
    },
    {
        path: "/login",
        name: "Login",
        component: () =>
            import ("../views/Login.vue"),
    },
    {
        path: "/change-password",
        name: "ChangePassword",
        component: () =>
            import ("../views/change-password.vue"),
    },
    {
        path: "/agent/getagentprofile",
        name: "getagentprofile",
        component: () =>
            import ("../views/agent/getagentprofile.vue"),
    },
    {
        path: "/profile",
        name: "Profile",
        component: () =>
            import ("../views/profile.vue"),
    },
    {
        path: "/payout-setting",
        name: "PayoutSetting",
        component: () =>
            import ("../views/payout-setting.vue"),
    },
    {
        path: "/agent/agentlist",
        name: "Downline",
        component: () =>
            import ("../views/agent/agentlist.vue"),
    },
    {
        path: "/agent/agentlist/:downlineId",
        name: "Downline",
        component: () =>
            import ("../views/agent/agentlist.vue"),
    },
    {
        path: "/agent/addagent",
        name: "Downline",
        component: () =>
            import ("../views/agent/addagent.vue"),
    },
    {
        path: "/payment/transfer",
        name: "Transfer",
        component: () =>
            import ("../views/payment/transfer.vue"),
    },
    {
        path: "/payment/statement",
        name: "Statement",
        component: () =>
            import ("../views/payment/statement.vue"),
    },
    {
        path: "/member/sub-account",
        name: "SubAccount",
        component: () =>
            import ("../views/member/sub-account.vue"),
    },
    {
        path: "/member/add-sub-account",
        name: "SubAccount",
        component: () =>
            import ("../views/member/add-sub-account.vue"),
    },
    {
        path: "/report/winLose",
        name: "winLose",
        component: () =>
            import ("../views/report/winLose.vue"),
    },
    {
        path: "/report/winLose/:userId",
        name: "winLoseById",
        component: () =>
            import ("../views/report/winLoseById.vue"),
    },
    {
        path: "/report/game",
        name: "ReportGame",
        component: () =>
            import ("../views/report/game.vue"),
    },
    {
        path: "/numLockUser",
        name: "numLockUser",
        component: () =>
            import ("../views/numLockUser.vue"),
    },
    {
        path: "*",
        name: "Not Found",
        component: () =>
            import ("../views/404.vue"),
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});
router.beforeEach(async(to, from, next) => {
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    if (requiresAuth) {
        next();
        return;
    }
    next();
});
export default router;